// extracted by mini-css-extract-plugin
export var categories = "thread-meta-module--categories--2BD8b";
export var container = "thread-meta-module--container--AAMVf";
export var counter = "thread-meta-module--counter--Fp7eI";
export var created = "thread-meta-module--created--BxY+M";
export var dot = "thread-meta-module--dot--t1DGN";
export var vertical = "thread-meta-module--vertical--utrS7";